import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import VBox from './VBox';

export default function WheelScroll(props) {
  const {
    onWheelUpward,
    onWheelDownward,
    children,
    total,
    size,
    current,
    ...rest
  } = props || {};

  const onWheel = React.useCallback((e) => {
    if (0 < e.deltaY) {
      onWheelUpward && onWheelUpward(e);
    } else {
      onWheelDownward && onWheelDownward(e);
    }
  }, [onWheelDownward, onWheelUpward]);

  const touchRef = React.useRef(null);
  const onTouchStart = React.useCallback((e) => {
    touchRef.current = e.touches[0].clientY;
  }, []);

  const onTouchMove = React.useCallback((e) => {
    const diff = e.touches[0].clientY - touchRef.current;
    if (30 < Math.abs(diff)) {
      if (diff < 0) {
        onWheelUpward && onWheelUpward(e);
      } else {
        onWheelDownward && onWheelDownward(e);
      }
      touchRef.current = e.touches[0].clientY;
    }
  }, [onWheelDownward, onWheelUpward]);

  return (
    <VBox
      {...ex('WheelScroll', rest)}
      {...{
        onWheel,
        onTouchStart,
        onTouchMove,
      }}
    >
      {children}
      <div {...ex('Scrollbar')}>
        <div
          {...ex('ScrollThumb')}
          {...{
            style: {
              top: `${(current / total * 100)}%`,
              height: `${size / total * 100}%`,
            },
          }}
        />
      </div>
    </VBox>
  );
}
